export const receiveBoardShareId = (state, { payload: { shareId } }) => ({
  ...state,
  shareId
});
